import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Tooltip as MuiTooltip, IconButton } from "@mui/material";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const Scorecard = ({ data }) => {
  const [scorecardData, setScorecardData] = useState({
    totalUnits: 0,
    totalFloorArea: 0,
    availableUnits: 0,
  });
  const [loading, setLoading] = useState();

  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate('/properties');
  };

  useEffect(() => {
    if (!data) {
      return;
    }
    let totalUnits = data.length;
    let totalFloorArea = data.reduce((sum, item) => sum + (item.floorArea || 0), 0);
    let availableUnits = totalUnits
    const scoreData = {
      totalUnits: totalUnits,
      totalFloorArea: totalFloorArea,
      availableUnits: availableUnits
    }

    // Simulate loading delay
    setTimeout(() => {
      setScorecardData(scoreData);
      setLoading(false);
    }, 500);
  }, [data]);

  if (loading) return <p>Loading scorecard...</p>;

  return (
    <div className="scorecard">
      <div className="tooltip-header" style={{ display: "flex", alignItems: "center" }}>
        <MuiTooltip title="These are the property statistics." arrow>
          <IconButton>
            <HelpOutlineIcon sx={{ fontSize: '18px', color: 'grey' }} />
          </IconButton>
        </MuiTooltip>
        <button className="redirect-btn" onClick={handleNavigate}>
          <i className="fa-solid fa-arrow-up-right-from-square"></i>
        </button>
      </div>

      <h2 className="scorecard-title">Property Overview</h2>

      <div className="scorecard-metric">
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <i className="fa-solid fa-home"></i>
          <p className="scorecard-metric-title">Number of Units</p>
        </div>
        <p className="scorecard-metric-value">{scorecardData.totalUnits}</p>
      </div>

      <div className="scorecard-metric">
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <i className="fa-solid fa-ruler"></i>
          <p className="scorecard-metric-title">Total Number of sq.m</p>
        </div>
        <p className="scorecard-metric-value">{scorecardData.totalFloorArea}</p>
      </div>

      <div className="scorecard-metric">
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <i className="fa-solid fa-sync-alt"></i>
          <p className="scorecard-metric-title">Total Units Turned Over</p>
        </div>
        <p className="scorecard-metric-value">{scorecardData.availableUnits}</p>
      </div>
    </div>
  );
};

export default Scorecard;